const handler = ($) => {

	/**
	 * Clear search input
	 */
	$('.search-form-clear, .resources-hub-filters .clear-search').on('click', function( e ) {
		e.preventDefault();

		const $el = $(this);

		$el.parents('form').find('input[type=text]').removeClass('is-active').val('').focus();
		$el.hide();

	});

	$('.page-template-page-tpl-community-conversations .questions-search .clear-search').on('click', function( e ) {
		e.preventDefault();

		window.location = location.protocol + '//' + location.host + location.pathname;

	});

	/**
	 * Display "clear" icon
	 */
	$('.page-template-page-tpl-community-conversations .questions-search input[type=text], .search-form-input, .resources-hub-filters input[type=text]').on('keyup', function( e ) {

		const $el = $(this),
		$searchClear = $el.parents('form').find('.search-form-clear, .clear-search');

		if( $el.val() != '' ) {
			$searchClear.show();
			$el.addClass('is-active');
		} else {
			$searchClear.hide();
			$el.removeClass('is-active');
		}

	});

};

export default (($) => $(handler))(jQuery);
